import React from "react";
import { NavLink } from "react-router-dom";
import { ACCOUNT_TABS, getAccountTabPath } from "./accountConfig";

type AccountTabsNavProps = {
  layout?: "bar" | "sidebar";
};

export default function AccountTabsNav({ layout = "bar" }: AccountTabsNavProps) {
  const isSidebar = layout === "sidebar";

  return (
    <div
      className={
        isSidebar
          ? "flex flex-col gap-0.5 p-2"
          : "px-2 py-1.5 dark:border-slate-700/80 dark:bg-slate-900/40 xl:hidden"
      }
      role="tablist"
      aria-label="Account sections"
    >
      <div
        className={
          isSidebar
            ? "flex flex-col gap-1"
            : "flex gap-1 overflow-x-auto pb-0.5 scrollbar-thin"
        }
      >
        {ACCOUNT_TABS.map(({ id, label, shortLabel, icon: Icon, description }) => (
            <NavLink
              key={id}
              to={getAccountTabPath(id)}
              role="tab"
              title={description}
              className={({ isActive }) =>
                `relative flex rounded-xl text-left transition-all duration-200 ${
                isSidebar
                  ? `w-full items-center gap-2.5 px-2.5 py-2 ${
                      isActive
                        ? "bg-primary text-white shadow-md shadow-primary/25"
                        : "text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800/80"
                    }`
                  : `min-w-[6.5rem] flex-1 flex-col items-start gap-0.5 px-2.5 py-2 sm:min-w-0 sm:flex-none sm:items-center sm:gap-1.5 sm:px-3 ${
                      isActive
                        ? "bg-white text-primary shadow-md shadow-slate-200/60 ring-1 ring-slate-200/80 dark:bg-slate-800 dark:text-primary dark:shadow-slate-900/40 dark:ring-slate-600/80"
                        : "text-slate-600 hover:bg-white/70 hover:text-slate-800 dark:text-slate-400 dark:hover:bg-slate-800/50 dark:hover:text-slate-200"
                    }`
              }`}
            >
              {({ isActive }) => (
                <>
              <Icon
                sx={{ fontSize: isSidebar ? 18 : 16 }}
                className={isActive && isSidebar ? "text-white" : isActive ? "text-primary" : ""}
              />
              <span className="min-w-0 flex-1">
                <span className="block text-xs font-semibold sm:text-sm">
                  {isSidebar ? label : (
                    <>
                      <span className="hidden sm:inline">{label}</span>
                      <span className="sm:hidden">{shortLabel}</span>
                    </>
                  )}
                </span>
                {isSidebar ? (
                  <span
                    className={`mt-px block text-[10px] font-medium leading-snug ${
                      isActive ? "text-white/80" : "text-slate-400 dark:text-slate-500"
                    }`}
                  >
                    {description}
                  </span>
                ) : (
                  <span
                    className={`hidden text-[10px] font-medium sm:block ${
                      isActive ? "text-slate-500 dark:text-slate-400" : "text-slate-400 dark:text-slate-500"
                    }`}
                  >
                    {description}
                  </span>
                )}
              </span>
              {isActive && !isSidebar ? (
                <span className="absolute bottom-0 left-3 right-3 hidden h-0.5 rounded-full bg-primary sm:block" />
              ) : null}
              {isActive && isSidebar ? (
                <span className="h-2 w-2 shrink-0 rounded-full bg-white/90" aria-hidden />
              ) : null}
                </>
              )}
            </NavLink>
          ))}
      </div>
    </div>
  );
}
